import { render, staticRenderFns } from "./callingDashboard.vue?vue&type=template&id=64fb5b20&scoped=true"
import script from "./callingDashboard.vue?vue&type=script&lang=js"
export * from "./callingDashboard.vue?vue&type=script&lang=js"
import style0 from "./callingDashboard.vue?vue&type=style&index=0&id=64fb5b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb5b20",
  null
  
)

export default component.exports